import { render, staticRenderFns } from "./StockSidebar.vue?vue&type=template&id=5df095d6&scoped=true&"
import script from "./StockSidebar.vue?vue&type=script&lang=js&"
export * from "./StockSidebar.vue?vue&type=script&lang=js&"
import style0 from "./StockSidebar.vue?vue&type=style&index=0&id=5df095d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df095d6",
  null
  
)

export default component.exports